import { render, staticRenderFns } from "./BankTransferModal.vue?vue&type=template&id=55163e3d&"
import script from "./BankTransferModal.vue?vue&type=script&lang=js&"
export * from "./BankTransferModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports